app.controller('headerCtrl', [
    'navService', 'appService', 'messageService', '$state', function (navService, appService, messageService, $state) {
        var vm = this;

    	vm.appService = appService;
    	vm.navService = navService;
        vm.messageService = messageService;

    	vm.openNav = function() {
    	   vm.navService.open();
    	}

    	vm.closeNav = function() {
    	   vm.navService.close();
    	}

    	vm.isLogin = function() {
    		return vm.isCurrentPage('student.login');
    	}

        vm.isFreeGame = function() {
            return vm.isCurrentPage('student.freegameperform');
        }

        vm.isPreview = function() {
            return vm.isCurrentPage('preview');
        }

        vm.isCurrentPage = function (state) {
            return $state.current.name.substring(0, state.length) === state;
        }

        vm.isStateOrAncestor = function (state) {
        	return $state.current.name.indexOf(state) == 0;
        }

    	vm.goHome = function() {
            if (vm.isPreview()) {
                return;
            }

    		if (vm.isCurrentPage('student')) {
    			$state.go('student');
            } else if (vm.isCurrentPage('teacherapp')) {
                $state.go('teacherapp');
    		} else {
    			$state.go('home');
    		}
    	}

        vm.goLogin = function() {
            $state.go('student.login');
        }

        vm.goTeacherMessages = function() {
            $state.go('teacherapp.messages');
        }

        vm.goStudentMessages = function() {
            $state.go('student.messages');
        }
    }
]);
